import { useState, useCallback } from "react";

export default function useTooltip(offset = { x: 10, y: 10 }) {
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const [tooltipText, setTooltipText] = useState("");
  const [activeId, setActiveId] = useState(null);

  const handleMouseEnter = (e, text, id) => {
    setTooltipText(text);
    setActiveId(id);
    setIsTooltipVisible(true);
    setTooltipPosition({
      x: e.clientX + offset.x,
      y: e.clientY + offset.y,
    });
  };

  const handleMouseMove = useCallback(
    e => {
      if (!isTooltipVisible) return;

      setTooltipPosition({
        x: e.clientX + offset.x,
        y: e.clientY + offset.y,
      });
    },
    [isTooltipVisible, offset]
  );

  const handleMouseLeave = useCallback(() => {
    setIsTooltipVisible(false);
    setTooltipText(null);
    setActiveId(null);
    setTooltipPosition({ x: 0, y: 0 });
  }, []);

  const handleClick = useCallback(() => {
    if (
      document.activeElement.tagName === "BUTTON" ||
      document.activeElement.tagName === "DIV"
    ) {
      setIsTooltipVisible(false);
      setActiveId(null);
    }
  }, []);

  return {
    tooltipPosition,
    isTooltipVisible,
    setIsTooltipVisible,
    handleMouseEnter,
    handleMouseMove,
    handleMouseLeave,
    tooltipText,
    handleClick,
    activeId,
  };
}